module.exports = __webpack_public_path__ + "static/media/group-577@3x.3d88547e.png";